// extracted by mini-css-extract-plugin
export default {"component":"uDk3h"};